export default {
  ko: {
    menu: {
      name: "메뉴",
      title: "메뉴 관리",
      search: {
        menuId: "메뉴 ID",
        menuNm: "메뉴 명",
      },
      columns: {
        regDt: "생성날짜",
        regId: "등록자 ID",
        sortSeq: "정렬순서",
        userLvl: "메뉴 사용자",
        updDt: "수정날짜",
        updId: "수정자 ID",
        useYn: "사용 여부",
        cntrCd: "센터 코드",
        coCd: "회사코드",
        menuDesc: "메뉴 설명",
        menuIcon: "메뉴 아이콘 이미지",
        mainShowIcon: "Dashboard 아이콘",
        menuId: "* 메뉴 ID",
        menuLvl: "* 메뉴 레벨",
        menuNm: "* 메뉴 명",
        menuType: "메뉴 종류",
        menuUrl: "* 메뉴 소스",
        parentId: "* 트리 부모 아이디",
        treeId: "* 트리 리스트 아이디",
      },
    },
  },
  en: {
    menu: {
      name: "Menu",
      title: "Menu Management",
      search: {
        menuId: "Menu ID",
        menuNm: "Menu Name",
      },
      columns: {
        regDt: "Registration Date",
        regId: "Register ID",
        sortSeq: "Sort By",
        userLvl: "User Level",
        updDt: "Update Date",
        updId: "Update ID",
        useYn: "Use or Not",
        cntrCd: "Center Code",
        coCd: "Company Code",
        menuDesc: "Menu Desc.",
        menuIcon: "Menu Icon Img.",
        mainShowIcon: "Dashboard Icon",
        menuId: "* Menu ID",
        menuLvl: "* Menu Level",
        menuNm: "* Menu Name",
        menuType: "Menu Type",
        menuUrl: "* Menu Source",
        parentId: "* Parant ID",
        treeId: "* Tree ID",
      },
    },
  },
  "zh-cn": {
    menu: {
      name: "Menu",
      title: "Menu Management",
      search: {
        menuId: "Menu ID",
        menuNm: "Menu Name",
      },
      columns: {
        regDt: "Registration Date",
        regId: "Register ID",
        sortSeq: "Sort By",
        userLvl: "User Level",
        updDt: "Update Date",
        updId: "Update ID",
        useYn: "Use or Not",
        cntrCd: "Center Code",
        coCd: "Company Code",
        menuDesc: "Menu Desc.",
        menuIcon: "Menu Icon Img.",
        mainShowIcon: "Dashboard Icon",
        menuId: "* Menu ID",
        menuLvl: "* Menu Level",
        menuNm: "* Menu Name",
        menuType: "Menu Type",
        menuUrl: "* Menu Source",
        parentId: "* Parant ID",
        treeId: "* Tree ID",
      },
    },
  }
};
